export default "__VITE_ASSET__acf312f6__"